import { startCase } from "../../utils/change-case"
import { TREMENDOUS_MARKETING_URL } from "../../utils/urls"

const WEBSITE_ROOT_NAME = "Tremendous"
export const SEO_TITLE_SUFFIX = " | Tremendous"

// For a given pathname e.g. /users/john-doe/profile/, these will be the items field result:
// 0 - 'https://www.tremendous.com/'
// 1 - 'https://www.tremendous.com/users/'
// 2 - 'https://www.tremendous.com/users/john-doe/'
// 3 - 'https://www.tremendous.com/users/john-doe/profile/'
export const getItemListElementFromPath = (pathname: string) => {
  const segments = [""].concat(pathname.split("/").filter(Boolean))

  return segments.map((path, index, acc) => ({
    "@type": "ListItem",
    position: index + 1,
    name: !index ? WEBSITE_ROOT_NAME : startCase(path),
    item: `${TREMENDOUS_MARKETING_URL}${acc.slice(0, index + 1).join("/")}/`,
  }))
}
